import {MoneyFormat} from "../Utilities/MoneyFormat";
import {DefaultButton, DetailsList, Selection, SelectionMode, Stack} from "@fluentui/react";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import AuthContext from "../Services/AuthContext";


function ProtocolPaymentList(props) {
    const [user] = useContext(AuthContext);
    const [sum, setSum] = useState(0)
    const [selection] = useState(new Selection({
        onSelectionChanged: () => setSum(selection.getSelection().reduce((p, c) => p + parseFloat(c.value), 0)),
    }));
    const cancelDonePayment = props.cancel ? props.cancel : false;
    const [activeButton, setActiveButton] = useState(true)
    let selectionMode = SelectionMode.none

    if (!cancelDonePayment) {
        selectionMode = SelectionMode.multiple
        useEffect( () => {
            if(sum > 0) {
                setActiveButton(false)
                console.log(selection.getSelection())
            } else {
                setActiveButton(true)
            }
        }, [sum])
    }

    const _update = () => {
        let selected = selection.getSelection()
        let selectedId = []
        selected.forEach( (i) => {
            selectedId.push(i.payment_id)
        })
        if(selectedId.length > 0) {
            fetch(`/api/payment/complete`, {
                method: 'PUT',
                body: JSON.stringify(selectedId),
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(json => { props.refresh() })
                .catch(err => { console.log(err) })
        }

    }

    const subheader = () => {
        if (!cancelDonePayment) {
            return (
                <Stack horizontal disableShrink horizontalAlign="start" verticalAlign="center" tokens={{childrenGap: 'l1'}}>
                    <DefaultButton disabled={activeButton} text={"Oznacz wybrane jako opłacone"} onClick={_update}/>
                    <h5>Zaznaczono: {MoneyFormat(sum)}</h5>
                </Stack>
            )
        }
    }

    return (
        <>
            {subheader()}
            <DetailsList items={props.data} columns={props.columns} selectionMode={selectionMode} selectionPreservedOnEmptyClick={true} selection={selection}/>
        </>
    )
}

export default ProtocolPaymentList;